import type { PlayerSnapshot } from '../types';

interface PlayerListProps {
  players: PlayerSnapshot[];
  currentPlayerId: string;
}

function playerStats(player: PlayerSnapshot): string {
  return `${player.words_completed} solved · ${player.words_attempted} guessed · ${player.incorrect_guesses} wrong`;
}

export function PlayerList({ players, currentPlayerId }: PlayerListProps) {
  return (
    <aside className="players-panel" aria-label="Players">
      <h2>Players ({players.length})</h2>
      <div className="players-list">
        {players.map((player) => (
          <div className="player-row" key={player.id}>
            <span className={`status-dot ${player.status}`} />
            <span aria-label={playerStats(player)} className="player-name" tabIndex={0}>
              {player.name}
              {player.id === currentPlayerId ? ' (you)' : ''}
              <span aria-hidden="true" className="info-tip-bubble">
                {playerStats(player)}
              </span>
            </span>
            <strong>{player.status === 'away' ? 'away' : `${player.points} pts`}</strong>
          </div>
        ))}
      </div>
    </aside>
  );
}
